export const creativeHeaders = [
  // { label: "S.No", key: "S.No", index: true },
  { label: "Image", key: "s3_file_name", type: "image" },
  {
    label: "Request Name",
    key: "requestName",
    type: "link",
    class: "text-blue-500 cursor-pointer",
  },
  { label: "Requested By", key: "assignedBy", subValues: true },
  { label: " Assigned Date", key: "createdAt" },
  { label: "Approved By", key: "approvedBy",  subValues: true  },
  { label: "Approved Date", key: "approvedBy",  subValues: true  },
  { label: "Status", key: "status", class: "text-green-600 font-bold" },
];
export const creativeUploadHeaders = [
  // { label: "S.No", key: "S.No", index: true },
  { label: "Image", key: "s3_file_name", type: "image" },
  {
    label: "Request Name",
    key: "requestName",
    type: "link",
    class: "text-blue-500 cursor-pointer",
  },
  // { label: "Approval By", key: "approvedBy", subValues: true },
  { label: " Assigned Date", key: "createdAt" },
  { label: "Approved By", key: "approvedBy",  subValues: true  },
  { label: "Approved Date", key: "approvedBy",  subValues: true  },
  { label: "Status", key: "status", class: "text-green-600 font-bold" },
];
export const creativeTableData = [
  {
    id: 1,
    date: "18/02/2025 04:30AM",
    post: "Post 123",
    platforms: "Facebook, Instagram",
    outlet: "Outlet 1",
    requestedBy: "example@gmail.com",
    status: "Success",
  },
];
export const creativeUploadRoles = [ "franchise", "agency_user", "agency_admin", "account_managers"]; // ["agency admin", "agency user"];
export const creativeApproveAndRejectRoles = ["head_office", "zonal", "regional_user", "franchise", "outlet", "agency_user", "agency_admin", "account_managers", "SuperAdmin"]; //  ["head_office", "zonal", "regional_user", "franchise", "outlet",  "agency_user",   "agency_admin"];
export const reassignRequestAccess = [ "agency_user", "agency_admin", "franchise", "account_managers"];
export const creativeClientRejectApproveAccess = ["head_office", "zonal", "regional_user"];
export const getAllRequestsByAccountName = ["agency admin", "client admin"];

